module.exports = __webpack_public_path__ + "static/media/whatsapp-atendimento.c519694a.png";